import { render } from "./PhotoShelf.vue?vue&type=template&id=3a5fa2d0"
import script from "./PhotoShelf.vue?vue&type=script&lang=js"
export * from "./PhotoShelf.vue?vue&type=script&lang=js"

import "./PhotoShelf.vue?vue&type=style&index=0&id=3a5fa2d0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__